import { apiClient } from "./ApiClient";

export const fetchCountryPrices = async ({
  skip = 0,
  limit = 20,
  currency = "USD",
  popular = false,
  location,
  name,
  language
} = {}) => {
  const params = {
    skip,
    limit,
    currency,
    popular,
    language
  };

  if (location) params.location = location;
  if (name) params.name = name;

  const { data } = await apiClient.get("/package/country/prices", { params });
  return data;
};

export async function fetchCountriesByRegion({ regionId, language, skip = 0, limit = 300 }) {
  const { data } = await apiClient.get("/country/batch", {
    params: {
      skip,
      limit,
      region_id: regionId,
      language: language,
    },
  });
  return data.items;
}
